export class LimitedStringSet {
  private _size: number;
  private data: object;
  private maxSize: number;

  constructor(maxSize: number = 100) {
    this._size = 0;
    this.data = {};
    this.maxSize = maxSize;
  }

  public add(value: string): void {
    if (this.has(value)) {
      return;
    }

    if (this.length >= this.maxSize) {
      this.removeFirst();
    }

    this.data[value] = true;
    this._size += 1;
  }

  public remove(value: string): void {
    if (this.data[value]) {
      delete this.data[value];
      this._size -= 1;
    }
  }

  public removeFirst(): void {
    for (const value in this.data) {
      if (this.data.hasOwnProperty(value)) {
        delete this.data[value];
        this._size -= 1;
        break;
      }
    }
  }

  public has(value: string): boolean {
    return Boolean(this.data[value]);
  }

  get length(): number {
    return this._size;
  }
}
